import { withDefault } from '@weft/utils';
import { useEffect } from 'react';
import { usePageParam } from './search-params/use-page-param';
import { usePageSizeParam } from './search-params/use-page-size-param';

export function usePaginationResetHandler(itemsLength: number) {
  const [page, setPage] = usePageParam();
  const [pageSize] = usePageSizeParam();

  useEffect(() => {
    const currentPage = withDefault(page, 0);

    if (currentPage > 0 && itemsLength === 0) {
      setPage(0);
    }
  }, [itemsLength, page, pageSize, setPage]);
}